import { keyframes } from 'styled-components'

const transitions = {
	blink: keyframes`
    50% {
      background: transparent;
    }
  `,
	fadeIn: keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `,
	fadeOut: keyframes`
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  `,
	popIn: keyframes`
    0% {
      transform: translateY(16px);
    }
    100% {
      transform: translateY(0px);
    }
  `,
	popOut: keyframes`
    0% {
      transform: translateY(0px);
    }
    100% {
      transform: translateY(16px);
    }
  `,
}

export default transitions
